import { render, staticRenderFns } from "./practitioners-filter.vue?vue&type=template&id=109fdb9a"
import script from "./practitioners-filter.vue?vue&type=script&lang=ts"
export * from "./practitioners-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports